module.exports = __webpack_public_path__ + "static/media/foto2.b3a02c3e.png";